import { BotFlow } from '@feedyou/schema'
import { DialogsPerTreeEntryPoint, getUsedDialogsPerTreeEntryPoint } from '@features/dialogRelation'

export function createStableEntryPointChildMapCreator() {
  let previousEntryPointChildMap: DialogsPerTreeEntryPoint | undefined

  return (flow: BotFlow | undefined): DialogsPerTreeEntryPoint => {
    const nextEntryPointChildMap = flow ? getUsedDialogsPerTreeEntryPoint(flow) : {}

    if (
      previousEntryPointChildMap &&
      areEntryPointChildMapsEqual(previousEntryPointChildMap, nextEntryPointChildMap)
    ) {
      return previousEntryPointChildMap
    }

    previousEntryPointChildMap = nextEntryPointChildMap

    return previousEntryPointChildMap
  }
}

function areEntryPointChildMapsEqual(
  left: DialogsPerTreeEntryPoint,
  right: DialogsPerTreeEntryPoint
): boolean {
  const leftKeys = Object.keys(left) as Array<keyof DialogsPerTreeEntryPoint>
  const rightKeys = Object.keys(right) as Array<keyof DialogsPerTreeEntryPoint>

  if (leftKeys.length !== rightKeys.length) {
    return false
  }

  return leftKeys.every(key => {
    return (
      Object.prototype.hasOwnProperty.call(right, key) &&
      areArraysEqual(left[key] ?? [], right[key] ?? [])
    )
  })
}

function areArraysEqual<T>(left: T[], right: T[]): boolean {
  if (left.length !== right.length) {
    return false
  }

  return left.every((value, index) => value === right[index])
}
